module.exports = __webpack_public_path__ + "static/t3-0fe7d2cd0635eba24c77c366b19f9190.png";